"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/core/styles");
var _theme = _interopRequireDefault(require("../../theme"));
const useStyles = (0, _styles.makeStyles)({
  rootMedia: {
    height: '250px',
    borderRadius: '5px',
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    boxShadow: "0 2px 4px 0 ".concat(_theme.default.palette.shadow, " "),
    '& img': {
      borderRadius: '5px',
      width: '100%',
      height: '100%',
      position: 'absolute'
    },
    [_theme.default.breakpoints.down('lg')]: {
      height: '210px'
    }
  },
  alphaFilter: {
    borderRadius: '5px',
    position: 'absolute',
    height: '100%',
    background: 'linear-gradient(93.84deg, rgba(0, 94, 220, 0.75) 6.95%, rgba(249, 211, 238, 0.75) 98.79%)',
    width: '100%',
    zIndex: 1,
    [_theme.default.breakpoints.down('lg')]: {
      height: '210px'
    }
  },
  content: {
    zIndex: 1,
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '0 30px',
    '& h1': {
      fontFamily: 'Kapra',
      fontSize: _theme.default.typography.pxToRem(64),
      lineHeight: _theme.default.typography.pxToRem(64),
      color: 'white',
      textTransform: 'uppercase',
      marginBottom: 0,
      textAlign: 'center',
      [_theme.default.breakpoints.down('lg')]: {
        fontSize: _theme.default.typography.pxToRem(48),
        lineHeight: _theme.default.typography.pxToRem(48)
      },
      [_theme.default.breakpoints.down('sm')]: {
        fontSize: _theme.default.typography.pxToRem(40),
        lineHeight: _theme.default.typography.pxToRem(40)
      },
      [_theme.default.breakpoints.down('330')]: {
        fontSize: _theme.default.typography.pxToRem(36),
        lineHeight: _theme.default.typography.pxToRem(36)
      }
    },
    '& p': {
      fontFamily: 'ProximaLight',
      color: 'white',
      fontSize: _theme.default.typography.pxToRem(18),
      lineHeight: _theme.default.typography.pxToRem(27),
      marginBottom: 0,
      textAlign: 'center',
      [_theme.default.breakpoints.down('md')]: {
        fontSize: _theme.default.typography.pxToRem(16),
        lineHeight: _theme.default.typography.pxToRem(24)
      }
    }
  },
  buttonLabel: {
    border: '1px solid white',
    borderRadius: 0,
    color: 'white',
    fontFamily: _theme.default.typography.proxima.semiBold,
    fontSize: _theme.default.typography.pxToRem(12),
    lineHeight: _theme.default.typography.pxToRem(15),
    margin: '8px 0 4px 0',
    padding: '13px 30px'
  }
});
var _default = exports.default = useStyles;